import React from 'react';
import './index.scss';
import { useSearchParams } from 'react-router-dom';
const Spinner = () => {
    var _a, _b, _c;
    const [searchParams] = useSearchParams();
    const isRokuBox = searchParams.get('device') === 'roku_box' || !!sessionStorage.getItem('isRokuBox');
    const brandLoader = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c.desktopLoader;
    // return <div className="spinner site-color"></div>  
    return React.createElement("div", { id: 'brand-loader', style: isRokuBox ? { background: '#000' } : {} },
        React.createElement("img", { src: brandLoader, role: "presentation" }));
};
export default Spinner;
